import { useEffect, useLayoutEffect, useState } from "react";
import SvgIcon from "../../common/SvgIcon";
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import { useTranslation } from "react-i18next";

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  Button,
} from "alm-react-components";
import { useSearchParams } from "react-router-dom";
import useNotesTabDataHook from "../../../hooks/useNotesTabDataHook";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../lib/utils";
import NotesRepliesById from "./NotesRepliesById";
import withAlmToken from "../../common/withAlmToken";
import PageLoader from "../../common/loader/PageLoader";

function ProgramNotes() {
  const [query] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [programNotesData, setProgramNotesData] = useState([]);
  const [isCommentEmpty, setIsCommentEmpty] = useState(false);
  const filterId = query.get("almCommentId");
  const { notesData, loading } = useNotesTabDataHook(isCommentEmpty);
  useEffect(() => {
    const res = notesData?.filter((res: any) => {
      return res?.almCommentId === filterId || res?.programId === filterId;
    });
    setProgramNotesData(res);
  }, [notesData, isCommentEmpty]);
  useLayoutEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <>
      <div>
        <div className="px-6 lg:px-8 xl:pr-32 xl:pl-32 pt-6 md:py-14 w-[100%] md:px-8 mb-12 flex-grow">
          <div className="flex justify-between items-center">
            <Button
              onClick={() => navigate("/home/my-stance")}
              variant="default"
              className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
            >
              <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
            </Button>
          </div>

          <div className="w-[100%] mx-auto py-6 md:py-7">
            <div className="lg:flex lg:items-center lg:justify-between mb-4 md:mb-0 flex-wrap justify-between md:pb-10">
              <h2
                className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light"
                dangerouslySetInnerHTML={{ __html: t("MyStance.programNotes") }}
              ></h2>
            </div>

            {programNotesData?.length > 0 ? (
              <>
                {programNotesData?.map((res: any) => {
                  return (
                    <>
                      {!res?.contextId ? (
                        <>
                          <Accordion
                            type="single"
                            collapsible
                            className="w-full mt-12"
                          >
                            <AccordionItem
                              value="item-1"
                              className="border-0 bg-[#212930] px-8 py-10 rounded-lg"
                            >
                              <AccordionTrigger className="relative programnotes-accordion text-base font-barlowLight hover:no-underline justify-start items-start md:flex-col lg:flex-row">
                                <div className="flex flex-row text-left pr-20">
                                  <div className="flex-none relative mr-6 mt-2">
                                    <SvgIcon
                                      iconName="program-notes-icon"
                                      svgProp={{
                                        className: "logo",
                                      }}
                                    />
                                  </div>
                                  <div className=" md:w-full lg:w-48 pt-4 text-left">
                                    <p className=" font-barlowRegular font-normal text-2xl">
                                      {res?.programName}
                                    </p>
                                  </div>
                                </div>
                                <div className="md:w-full lg:w-full text-left md:pl-20 lg:pl-0 md:pt-8 lg:pt-0">
                                  <p className=" font-opensansLight text-sm">
                                    {formatDate(res?.createdAt)}
                                  </p>
                                  <p className=" font-barlowRegular font-normal uppercase text-xl">
                                    <span className="font-barlowLight font-light uppercase text-xl pr-2">
                                      {res?.courseName}
                                    </span>
                                  </p>
                                </div>
                              </AccordionTrigger>
                              <AccordionContent className="text-base font-barlowLight space-y-5">
                                <div className="flex flex-col w-full pl-20 pt-6">
                                  <p className="font-opensansSemiBold text-lg">
                                    {t("MyStance.notes")}
                                  </p>
                                  <NotesRepliesById
                                    commentId={res?.almCommentId}
                                    setIsCommentEmpty={setIsCommentEmpty}
                                  />
                                </div>
                              </AccordionContent>
                            </AccordionItem>
                          </Accordion>
                        </>
                      ) : (
                        <>
                          <Accordion
                            defaultValue="item-1"
                            type="single"
                            collapsible
                            className="w-full mt-12"
                          >
                            <AccordionItem
                              value="item-1"
                              className="border-0 bg-[#212930] px-8 py-10 rounded-lg"
                            >
                              {/* <AccordionTrigger className="relative programnotes-accordion text-base font-barlowLight hover:no-underline justify-start items-start md:flex-col lg:flex-row"> */}
                              <div className="flex flex-row text-left pr-20">
                                <div className="flex-none relative mr-6 mt-2">
                                  <SvgIcon
                                    iconName="program-notes-icon"
                                    svgProp={{
                                      className: "logo",
                                    }}
                                  />
                                </div>
                                <div className=" md:w-full lg:w-full  text-left">
                                  <p className=" font-barlowRegular pt-4 font-normal text-2xl">
                                    {res?.courseName}
                                  </p>
                                </div>
                              </div>
                              {/* </AccordionTrigger> */}
                              <AccordionContent className="text-base font-barlowLight space-y-5">
                                <div className="flex flex-col w-full pl-20 pt-6">
                                  <p className="font-opensansSemiBold text-lg">
                                    {t("MyStance.notes")}
                                  </p>
                                  <NotesRepliesById
                                    commentId={res?.almCommentId}
                                    setIsCommentEmpty={setIsCommentEmpty}
                                  />
                                </div>
                              </AccordionContent>
                            </AccordionItem>
                          </Accordion>
                        </>
                      )}
                    </>
                  );
                })}
              </>
            ) : (
              <>
                <div
                  className="flex justify-center w-full text-2xl"
                  dangerouslySetInnerHTML={{
                    __html: t("MyStance.NoNoteAvailable"),
                  }}
                ></div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default withAlmToken(ProgramNotes);
